import { InteractiveQuickKey } from "../../../InteractiveQuickKey";
import { useMakeCommonQuickKeyProps } from "../../hooks";
import { ActionItemRenderer } from "./ActionItemRenderer";
import { ActionItemRendererProps } from "./types";

export const DynamicActionItemRenderer = ({
  item,
  beforeDrag,
}: ActionItemRendererProps) => {
  const { makeCommonQuickKeyProps } = useMakeCommonQuickKeyProps();
  const interactiveProps = makeCommonQuickKeyProps(item);

  return (
    <InteractiveQuickKey {...interactiveProps} beforeDrag={beforeDrag}>
      <ActionItemRenderer {...{ item }} />
    </InteractiveQuickKey>
  );
};
